import { render, staticRenderFns } from "./identification_finish.vue?vue&type=template&id=01c1bc33&scoped=true"
import script from "./identification_finish.vue?vue&type=script&lang=js"
export * from "./identification_finish.vue?vue&type=script&lang=js"
import style0 from "./identification_finish.vue?vue&type=style&index=0&id=01c1bc33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1bc33",
  null
  
)

export default component.exports